export default "__VITE_ASSET__Bec1tqEg__"